// test2248
(2248 && 0);
